import { render, staticRenderFns } from "./_gameResultChangesLog.vue?vue&type=template&id=1694dfd6&lang=pug"
import script from "./_gameResultChangesLog.vue?vue&type=script&lang=js"
export * from "./_gameResultChangesLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports